import React, { useEffect } from 'react'
import { Table } from '@imcva/reactstrap-table'
import { useCardContext } from 'src/components/Card/CardContext'
import { useDistributionSubcategoryStatuses, useStaffingAgencies } from 'src/queries'
import { columns as makeColumns } from './columns'

const Body: React.FC = (props) => {
  const staffingagencies = useStaffingAgencies()
  const statuses = useDistributionSubcategoryStatuses()
  const card = useCardContext()
  const count = staffingagencies.length
  const columns = makeColumns(statuses.map((status) => status.label))
  useEffect(() => {
    card.setTitle(`Staffing Agencies (${String(count)})`)
  }, [count])
  return (
    <Table storageKey='cat-staffingagencies' options={{ data: staffingagencies, columns, initialState: { sorting: [{ id: 'name', desc: false }] } }} />
  )
}

export default Body
